// actions
const UPDATE_DOCUMENT_PREVIEW_STATE = 'DOCUMENT/PREVIEW/UPDATE_STATE'

// reducer
const initialState = {
  isLoading: false,
  isRebuilding: false,
  isDocumentReady: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_DOCUMENT_PREVIEW_STATE:
      const { isLoading, isRebuilding } = action.data
      const newState = { ...state }
      if (isLoading !== undefined) {
        newState.isLoading = isLoading
      }
      if (isRebuilding !== undefined) {
        newState.isRebuilding = isRebuilding
      }
      newState.isDocumentReady = !(newState.isLoading || newState.isRebuilding)
      return newState

    default:
      return state
  }
}

// action creators
export const updateDocumentPreviewState = (state) => {
  return {
    type: UPDATE_DOCUMENT_PREVIEW_STATE,
    data: state,
  }
}
